import React from 'react'
import HorizontalTabs from '../components/HorizontalTabs';
import { Link } from 'react-router-dom';

function parentorientationforpyp() {
  const tabs = [
    { title: 'Parent Orientation to PYP', content: () => <div>
    
    <div className='cam-lower-sec'>
    <h1 className='title'>Parent Orientation to PYP</h1>
    </div>
    <p>Welcome Dear Parents to the Sanskar family.</p>
    <p>Keeping in view the present scenario of Covid-19, we have tried our best to apprise our community about the teaching-learning methodology followed at Sanskar through a short Orientation video / PDF.</p>
    <p>Kindly click on the link to follow: <Link to="https://www.youtube.com/watch?v=9SlsmId1XbY">https://youtu.be/9SlsmId1XbY</Link> For further queries/doubts, feel free to call 8824675529</p>

    <div className='syllubus-data'>
      <div className='syllubs-list'>
      <Link to="">download now</Link>
      </div>

    </div>
    </div> },

  ];
  return (
    <div>
       <div className='ib-syllabus  '>
        {/* <Igcsedata/> */}
        <HorizontalTabs tabs={tabs} />
      </div>
    </div>
  )
}

export default parentorientationforpyp
